import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, Empty, Modal, Input } from "antd";
import {
  Loading3QuartersOutlined,
  DeleteOutlined,
  EyeOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import "./Projects.css";
import Axios from "axios";
import constants from "../constants/constants.json";
import moment from "moment";
import Message from "../helper/Message";
import ConfirmModal from "../components/ConfirmModal";
import { SendOutlined } from "@material-ui/icons";

export default function Projects(props) {
  const [loading, setloading] = useState(false);
  const [loadingNew, setLoadingNew] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState(false);
  const [projectName, setProjectName] = useState(null);
  const [open, setOpen] = useState(false);
  const [projectData, setProjectData] = useState(false);
  const [email, setEmail] = useState(null);
  const [sendLoading, setSendLoading] = useState(false);

  const listProject = async () => {
    setloading(true);
    try {
      let token = localStorage.getItem("pnsToken");
      let response = await Axios.get(constants.url + "/project/list", {
        headers: {
          authorization: "Bearer " + token,
        },
      });
      if (response.data.status === 202) {
        setProjects(response.data.result.projects);
        setloading(false);
      } else {
        setloading(false);
        Message.error(response.data.result.message);
      }
    } catch (error) {
      setloading(false);
      Message.error("Communication error");
    }
  };

  const ProjectNew = async () => {
    setLoadingNew(true);
    try {
      let token = localStorage.getItem("pnsToken");
      let response = await Axios.get(constants.url + "/project/new", {
        headers: {
          authorization: "Bearer " + token,
        },
      });
      if (response.data.status === 202) {
        setLoadingNew(false);
        Message.success("The project was created successfully");
        listProject();
      } else {
        setLoadingNew(false);
        Message.error(response.data.result.message);
      }
    } catch (err) {
      setLoadingNew(false);
      Message.error("Communication error");
    }
  };

  const projectDelete = async () => {
    try {
      setLoadingRemove(true);
      let token = localStorage.getItem("pnsToken");
      let response = await Axios.delete(
        constants.url + "/project/delete/" + projectId,
        {
          headers: {
            authorization: "Bearer " + token,
          },
        }
      );
      if (response.data.status === 202) {
        Message.success("The project was removed successfully ");
        setLoadingRemove(false);
        setVisible(false);
        listProject();
      } else {
        Message.error(response.data.result.message);
        setLoadingRemove(false);
        setVisible(false);
      }
    } catch (err) {
      setLoadingRemove(false);
      setVisible(false);
      Message.error("Communication error");
    }
  };

  const saveAs = async (project) => {
    try {
      let token = localStorage.getItem("pnsToken");

      const resProject = await Axios.get(
        constants.url + "/project/open/" + project.uid,

        {
          headers: {
            authorization: "Bearer " + token,
          },
        }
      );

      let response = await Axios.post(
        constants.url + "/project/saveas/",
        {
          projectUID: project.uid,
          projectName,
          data: {
            comparisons: resProject.data.result.project.data.comparisons,
            lines: resProject.data.result.project.data.lines,
            option: resProject.data.result.project.data.option,
            shapes: resProject.data.result.project.data.shapes,
          },
        },
        {
          headers: {
            authorization: "Bearer " + token,
          },
        }
      );
      setOpen(false);
      listProject();
    } catch (error) {
      Message.error("Communication error");
    }
  };

  const sendProject = async () => {
    try {
      setSendLoading(true);

      const res = await Axios.post(
        `${constants.url}/project/sendTo`,
        {
          projectUID: projectData.uid,
          sendUserEmail: email,
        },
        {
          headers: {
            authorization: "Bearer " + localStorage.getItem("pnsToken"),
          },
        }
      );
      if (res.data.status === 201) {
        Message.success(res.data.result.message);
      } else {
        Message.warning(res.data.result.message);
      }
      setSendLoading(false);
      setOpen(false);
      setEmail(null);
    } catch (error) {
      setSendLoading(false);
      Message.error("Communication error");
    }
  };

  useEffect(() => {
    listProject();
  }, []);

  return loading ? (
    <div className="projects-loding">
      <Loading3QuartersOutlined spin className="loading-projects-icon" />
    </div>
  ) : (
    <Row gutter={[20, 20]}>
      <Col span={24}>
        <Row align="middle" justify="space-between">
          <span className="projects-title">Projects</span>
          <Button
            onClick={ProjectNew}
            type="primary"
            loading={loadingNew ? <Loading3QuartersOutlined spin /> : false}
          >
            Create New Project
          </Button>
        </Row>
      </Col>

      {projects.length > 0 ? (
        projects.map((item, index) => {
          return (
            <Col xs={24} sm={24} md={20} lg={6}>
              <Card
                // hoverable
                bodyStyle={{
                  paddingRight: "0",
                  paddingLeft: "0",
                  paddingBottom: "0",
                  paddingTop: "0",
                }}
                key={index}
              >
                <div className="project-card">
                  <span className="project-card-label">
                    {" "}
                    <span className="project-name">
                      {item.name ? item.name : "New Project"}
                    </span>
                  </span>
                  <span className="project-card-label">
                    Usage Time:{" "}
                    <span className="project-card-font-value">
                      {item.usage} Seconds
                    </span>
                  </span>
                  <Row justify="space-between">
                    <span className="project-card-label">
                      Create:{" "}
                      <span className="project-card-font-value">
                        {moment.unix(item.create).format("YYYY/MM/DD HH:mm")}
                      </span>
                    </span>
                    <span className="project-card-label">
                      Last Edit:{" "}
                      <span className="project-card-font-value">
                        {moment
                          .unix(item.manipulate)
                          .format("YYYY/MM/DD HH:mm")}
                      </span>
                    </span>
                  </Row>
                </div>
                {/* {index === indexShow && ( */}
                <div className="card-extension">
                  <a href={`/project/${item.uid}`}>
                    <EyeOutlined
                      title="view project"
                      style={{
                        fontSize: 25,
                        color: "green",
                        cursor: "pointer",
                      }}
                    />
                  </a>
                  <SaveOutlined
                    title="saveAs project"
                    onClick={() => {
                      setProjectData(item);
                      setOpen("saveas");
                    }}
                    style={{ fontSize: 25, cursor: "pointer" }}
                  />
                  <SendOutlined
                    titleAccess="send project to other users"
                    onClick={() => {
                      setProjectData(item);
                      setOpen("send");
                    }}
                    style={{ fontSize: 25, cursor: "pointer" }}
                  />
                  <div
                    onClick={() => {
                      setVisible(true);
                      setProjectId(item.uid);
                    }}
                  >
                    <DeleteOutlined
                      title="remove project"
                      style={{
                        color: "red",
                        fontSize: "25px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
                {/* )} */}
              </Card>
            </Col>
          );
        })
      ) : (
        <Empty
          style={{
            color: "white",
            width: "100%",
            marginTop: "50px",
          }}
          description="There is no project yet!"
        >
          <Button
            type="primary"
            onClick={ProjectNew}
            loading={loadingNew ? <Loading3QuartersOutlined spin /> : false}
          >
            Create New Project
          </Button>
        </Empty>
      )}
      <ConfirmModal
        runFunc={projectDelete}
        loading={loadingRemove}
        msg={"Are you sure?"}
        visible={visible}
        setVisible={setVisible}
      />
      <Modal
        title={open === "send" ? "send project" : "save as"}
        onOk={() => {
          open === "send" ? sendProject() : saveAs(projectData);
        }}
        okButtonProps={{ loading: sendLoading }}
        open={open}
        onCancel={() => setOpen(false)}
      >
        <div>project : {projectData.name}</div>
        <br />
        {open === "send" ? (
          <Input
            placeholder="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        ) : (
          <Input
            placeholder="name"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
          />
        )}
      </Modal>
    </Row>
  );
}
